module.exports = __webpack_public_path__ + "img/pi3ckheadersection.c4e28aa6.png";